import { Component, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';
import { Injectable } from '@angular/core';
import { Http, Headers, Response, RequestOptions} from '@angular/http';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Rx';
import { AppConfig } from 'app/app.config';
// Import navigation elements
import { navigation, navigationUniversidad, navigationEvaluador } from './../../_nav';

@Component({
  selector: 'app-sidebar-nav',
  template: `
    <nav class="sidebar-nav">
      <ul class="nav">
        <ng-template ngFor let-navitem [ngForOf]="navigation">
          <li *ngIf="isDivider(navitem)" class="nav-divider"></li>
          <ng-template [ngIf]="isTitle(navitem)">
            <app-sidebar-nav-title [title]='navitem'></app-sidebar-nav-title>
          </ng-template>
          <ng-template [ngIf]="!isDivider(navitem)&&!isTitle(navitem)">
            <app-sidebar-nav-item [item]='navitem'></app-sidebar-nav-item>
          </ng-template>
        </ng-template>
      </ul>
    </nav>`
})
export class AppSidebarNavComponent {

  navigation: any;
  rol: any;

  public isDivider(item) {
    return item.divider ? true : false
  }

  public isTitle(item) {
    return item.title ? true : false
  }

  constructor() { 

    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    this.rol=currentUser.rol;
    if (this.rol == "3")
    {
      this.navigation=navigationUniversidad;
    }
    if (this.rol == "2")
    {
      this.navigation=navigationEvaluador;
    }
    else
    {
      this.navigation=navigation;
    }


  }
}

import { Router } from '@angular/router';

@Component({
  selector: 'app-sidebar-nav-item',
  template: `
    <li *ngIf="!isDropdown(); else dropdown" [ngClass]="hasClass() ? 'nav-item ' + item.class : 'nav-item'">
      <app-sidebar-nav-link [link]='item'></app-sidebar-nav-link>
    </li>
    <ng-template #dropdown>
      <li [ngClass]="hasClass() ? 'nav-item nav-dropdown ' + item.class : 'nav-item nav-dropdown'"
          [class.open]="isActive()"
          routerLinkActive="open"
          appNavDropdown>
        <app-sidebar-nav-dropdown [link]='item'></app-sidebar-nav-dropdown>
      </li>
    </ng-template>
    `
})
export class AppSidebarNavItemComponent {
  @Input() item: any;

  public hasClass() {
    return this.item.class ? true : false
  }

  public isDropdown() {
    return this.item.children ? true : false
  }

  public thisUrl() {
    return this.item.url
  }

  public isActive() {
    return this.router.isActive(this.thisUrl(), false)
  }

  constructor( private router: Router )  { }

}

@Component({
  selector: 'app-sidebar-nav-link',
  template: `
    <a *ngIf="!isDoc(); else doc"
      [ngClass]="hasVariant() ? 'nav-link nav-link-' + link.variant : 'nav-link'"
      routerLinkActive="active"
      [routerLink]="[link.url]">
      <i *ngIf="isIcon()" class="{{ link.icon }}"></i>
      {{ link.name }}
      <span *ngIf="isBadge()" [ngClass]="'badge badge-' + link.badge.variant">{{ link.badge.text }}</span>
    </a>

    <ng-template #external>
      <a [ngClass]="hasVariant() ? 'nav-link nav-link-' + link.variant : 'nav-link'" href="{{link.url}}" target=_blank style="font-size:13px;">
        <i *ngIf="isIcon()" class="{{ link.icon }}"></i>
        {{ link.name }}
        <span *ngIf="isBadge()" [ngClass]="'badge badge-' + link.badge.variant">{{ link.badge.text }}</span>
      </a>
    </ng-template>
    <ng-template #doc>
    <span [ngClass]="hasVariant() ? 'nav-link nav-link-' + link.variant : 'nav-link'" style="font-size:13px;cursor: pointer;"  (click)="verDocumentacion(link.idconvocatoria,link.idtipodocumentacion)">
      <i *ngIf="isIcon()" class="{{ link.icon }}"></i>
      {{ link.name }}
      </span>
  </ng-template>
  `
})
export class AppSidebarNavLinkComponent {
  @Input() link: any;

  public hasVariant() {
    return this.link.variant ? true : false
  }

  public isBadge() {
    return this.link.badge ? true : false
  }


  public isDoc() {
    return this.link.idtipodocumentacion ? true : false
  }


  public isExternalLink() {
    return this.link.url.substring(0, 4) === 'http' ? true : false
  }

  public isIcon() {
    return this.link.icon ? true : false
  }

  constructor(private http: Http, private config: AppConfig) { }

  getDOCUMENTACION(idconvocatoria, idtipodocumento) {
    const parametros = idconvocatoria + "/" +idtipodocumento  ;
    let action= '';
    action = '/convocatoria/documento/';
    console.log(this.config.apiUrl + action + parametros);
    return this.http.get(this.config.apiUrl + action + parametros, this.jwtBlob()).map((response: Response) => response.text());
  
  }

  verDocumentacion(idconvocatoria,idtipodocumentacion) {

    this.getDOCUMENTACION(idconvocatoria,idtipodocumentacion)
    .subscribe( data => {
  
      var binaryImg = atob(data);
      var length = binaryImg.length;
      var ab = new ArrayBuffer(length);
      var ua = new Uint8Array(ab);
      for (var i = 0; i < length; i++) {
          ua[i] = binaryImg.charCodeAt(i);
      }
      let tipoDocumentacion='';

      if (idtipodocumentacion==1){ tipoDocumentacion='application/pdf'; }
      if (idtipodocumentacion==2){ tipoDocumentacion='application/msword'; }
      if (idtipodocumentacion==3){ tipoDocumentacion='application/pdf'; }
      if (idtipodocumentacion==4){ tipoDocumentacion='application/pdf'; }
      if (idtipodocumentacion==5){ tipoDocumentacion='application/msword'; }


      const DOCUMENTACION = new Blob([ua], {type: tipoDocumentacion});
      const strURL = URL.createObjectURL(DOCUMENTACION);
      
      if(idtipodocumentacion==2 || idtipodocumentacion==5){
      var link = document.createElement('a');
      link.href = strURL;
      link.download="modelo.doc";
      link.click();
      }else{
        window.open(strURL);
      }
      },
      error => {if (error.status = 401) {alert(error); }}
    );

  }

  private jwtBlob() {
    // create authorization header with jwt token
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    if (currentUser && currentUser.token) {
        const headers = new Headers({ 'Authorization': 'Bearer ' + currentUser.token });
        // headers = new Headers({ResponseContentType : Text});
        return new RequestOptions({ headers: headers });
    }
  }

}

@Component({
  selector: 'app-sidebar-nav-dropdown',
  template: `
    <a class="nav-link nav-dropdown-toggle" appNavDropdownToggle>
      <i *ngIf="isIcon()" class="{{ link.icon }}"></i>
      {{ link.name }}
      <span *ngIf="isBadge()" [ngClass]="'badge badge-' + link.badge.variant">{{ link.badge.text }}</span>
    </a>
    <ul class="nav-dropdown-items">
      <ng-template ngFor let-child [ngForOf]="link.children">
        <app-sidebar-nav-item [item]='child'></app-sidebar-nav-item>
      </ng-template>
    </ul>
  `
})
export class AppSidebarNavDropdownComponent {
  @Input() link: any;

  public isBadge() {
    return this.link.badge ? true : false
  }

  public isIcon() {
    return this.link.icon ? true : false
  }

  constructor() { }
}

@Component({
  selector: 'app-sidebar-nav-title',
  template: ''
})
export class AppSidebarNavTitleComponent implements OnInit {
  @Input() title: any;

  constructor(private el: ElementRef, private renderer: Renderer2) { }

  ngOnInit() {
    const nativeElement: HTMLElement = this.el.nativeElement;
    const li = this.renderer.createElement('li');
    const name = this.renderer.createText(this.title.name);

    this.renderer.addClass(li, 'nav-title');

    if ( this.title.class ) {
      const classes = this.title.class;
      this.renderer.addClass(li, classes);
    }

    if ( this.title.wrapper ) {
      const wrapper = this.renderer.createElement(this.title.wrapper.element);

      this.renderer.appendChild(wrapper, name);
      this.renderer.appendChild(li, wrapper);
    } else {
      this.renderer.appendChild(li, name);
    }
    this.renderer.appendChild(nativeElement, li)
  }
}

export const APP_SIDEBAR_NAV = [
  AppSidebarNavComponent,
  AppSidebarNavDropdownComponent,
  AppSidebarNavItemComponent,
  AppSidebarNavLinkComponent,
  AppSidebarNavTitleComponent
];



// WEBPACK FOOTER //
// /app/src/app/components/app-sidebar-nav/app-sidebar-nav.component.ts